<template>
    <div>
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <br /> <br />
                <CCard class="bg-white b-20 m-1 p-20 mb-5" style="border:none;">
                    <div class="p-2 ml-3 mt-3 mr-3"> <img style="max-width:200px" src="../assets/img/Welcome.png" />
                        <p class="custom-16px-500 font-color-687588 mt-3 text-left">Your progress this week is impressive. Let's maintain this momentum and identify the best candidate for the role</p>
                    </div>
                    <CRow>
                        <CCol sm="4">
                            <CCard class="custom-border-purple-20 m-2">
                                <div class="p-2">
                                    <img src="../assets/img/multipleuser.png" style="max-width:50px" class="m-2" />
                                    <p class="custom-18px-500 mt-2 text-white">
                                        Total Candidate
                                    </p>
                                    <CRow class="mt-4">
                                        <CCol sm="6">
                                            <h3 class="custom-24px-500 ml-2 text-white">{{ chartCandidate.countCurrentMonth + chartCandidate.countPreviousMonthCurrentYear }}</h3>
                                        </CCol>
                                        <CCol sm="6" class="text-right">
                                            <label class="badge-purple">
                                                                                    <img v-if="chartCandidate.percentageChangeDirection ==='Up'" src="../assets/img/TrendUp.png" style="max-width:20px" class="ml-2 mt-1"/>
                                                                                    <img v-else src="../assets/img/arrowdown.png" style="max-width:20px" class="ml-2 mt-1"/>
                                                                                    <label class="custom-12px-500 ml-3 mt-2 mr-3">
                  {{ Math.round(chartCandidate.percentageChange) }} %
                </label>
                                            </label>
                                        </CCol>
                                        <CCol sm="6">
                                            <p class="custom-14px-500 ml-2 text-white" style="opacity:0.64">This Month </p>
                                        </CCol>
                                        <CCol sm="6">
                                            <p class="custom-14px-500 text-right mr-2 text-white"> {{ chartCandidate.countCurrentMonth }}</p>
                                        </CCol>
    
                                        <CCol sm="6">
                                            <p class="custom-14px-500 ml-2 text-white" style="opacity:0.64">{{ chartCandidate.monthCurrentYearPreviousMonth }}</p>
                                        </CCol>
                                        <CCol sm="6">
                                            <p class="custom-14px-500 text-right mr-2 text-white">{{ chartCandidate.countPreviousMonthCurrentYear }}</p>
                                        </CCol>
                                    </CRow>
                                </div>
    
                            </CCard>
                        </CCol>
    
                        <CCol sm="4">
                            <CCard class="m-2 b-20">
                                <div class="p-2">
                                    <img src="../assets/img/icon.png" style="max-width:50px" class="m-2" />
                                    <p class="custom-18px-500 m-2 font-color-171717">
                                        Selected Candidate
                                    </p>
                                    <CRow>
                                        <CCol sm="12">
                                            <h3 class="custom-24px-500 ml-2 font-color-171717">{{ selectedCandidate.Total }}</h3>
                                            <hr class="custom-hr-EAECF0" />
                                        </CCol>
    
                                        <CCol sm="6">
                                            <p class="custom-14px-500 ml-2 font-color-171717" style="opacity:0.64">This Month </p>
                                        </CCol>
                                        <CCol sm="6">
                                            <p class="custom-14px-500 text-right mr-2 font-color-171717">{{ selectedCandidate.ThisMonth }}</p>
                                        </CCol>
    
                                        <CCol sm="6">
                                            <p class="custom-14px-500 ml-2 font-color-171717" style="opacity:0.64">{{ selectedCandidate.PreviousMonth }}</p>
                                        </CCol>
                                        <CCol sm="6">
                                            <p class="custom-14px-500 text-right mr-2 font-color-171717">{{ selectedCandidate.Previous }}</p>
                                        </CCol>
                                    </CRow>
                                </div>
    
                            </CCard>
                        </CCol>
                        <CCol sm="4">
                            <CCard class="m-2 b-20">
                                <div class="p-2">
    
                                    <CRow>
    
                                         <CCol sm="6">
                                            <p class="custom-14px-500 ml-2" style="opacity:0.64"> </p>
                                        </CCol>
                                        <CCol sm="6">
                                            <CCard class="b-20">
                                                <label class="custom-12px-500 m-2 font-color-171717"><img src="../assets/img/calendar.png" style="max-width:20px" class="mr-2"/>Monthly</label>
    
                                            </CCard>
    
                                        </CCol> 
                                        <CCol sm="12" class="mt-3">
                                            <CChartDoughnut :datasets="defaultDatasetsDoughnut" :labels="['Positive', 'Negative']" :options="chartOptions" />
                                            <CRow class="mt-1">
                                                <CCol sm="6">
                                                    <CRow>
                                                        <CCol sm="6" class="font-color-171717"><label class="custom-14px-500">Positive</label></CCol>
                                                        <CCol sm="6" class="font-color-171717">{{ positivePercentage }}%</CCol>
                                                    </CRow>
                                                </CCol>
                                                <CCol sm="6">
                                                    <CRow>
                                                        <CCol sm="6" class="font-color-171717"><label class="custom-14px-500">Negative</label></CCol>
                                                        <CCol sm="6" class="font-color-171717">{{ negativePercentage }}%</CCol>
                                                    </CRow>
                                                </CCol>
                                            </CRow>
                                        </CCol>
    
    
                                    </CRow>
                                </div>
    
                            </CCard>
                        </CCol>
    
                        <CCol sm="12">
                            <CCol sm="12">
    
                                <h3 class="custom-24px-500 m-3">Average Personality</h3>
                                <CRow>
                                    <CCol sm="4" v-for="item in category" :key="item.Id">
    <CCard class="p-2">
      <h3 class="custom-16px-500 text-left mt-2 font-color-171717">{{ item.Category }}</h3>
      <br />
      <CProgress :value="item.GlobalAvgValue" max="10" :precision="2" color="5D8AFC" class="mb-2" />
      <br />
      <CProgress :value="item.CompanySelectedAvgValue" max="10" :precision="2" color="D760B6" class="mb-2" />
      <br />
      <div class="progress-scale font-color-171717">
        <span v-for="mark in scaleMarks" :key="mark" class="scale-mark">{{ mark }}</span>
      </div>
      <br />
      <CRow class="ml-2">
        <img src="../assets/img/pink-info.png" style="width:10px;height:10px" class="mt-1 mr-2" />
        <label class="font-color-696969">Your Candidate</label>
        <img src="../assets/img/blue-info.png" style="width:10px;height:10px" class="ml-5 mt-1 mr-2" />
        <label class="font-color-696969">Global</label>
      </CRow>
    </CCard>
  </CCol>
                                </CRow>
    
                            </CCol>
    
                        </CCol>
    
    
                    </CRow>
    
                </CCard>
    
                <br /><br /><br />
            </CCol>
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'



export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isPopupVisible2: false,
            list: [],
            user: {},
            isPopupVisible3: false,
            videoUrl: '',
            searchQuery: '',
            defaultDatasetsDoughnut: [],
            pn:null,
            positiveValue: 0,                  // Store positive value
      negativeValue: 0,                  // Store negative value
      positivePercentage: 0,              // Calculate percentage for positive
      negativePercentage: 0, 
            defaultDatasets: [{
                label: 'Candidate',
                backgroundColor: ['#928AFD', '#F2F1FF'],
                data: []
            }],
            defaultDatasets1: [{
                    label: 'Tech',
                    backgroundColor: '#FC7D5D',
                    borderColor: '#FC7D5D',
                    borderWidth: 1,
                    data: [15, 20, 30, 40] // Values for each month
                },
                {
                    label: 'Designer',
                    backgroundColor: '#229E88',
                    borderColor: '#229E88',
                    borderWidth: 1,
                    data: [15, 25, 35, 45] // Values for each month
                },
                {
                    label: 'Marketing',
                    backgroundColor: '#F7CC0E',
                    borderColor: '#F7CC0E',
                    borderWidth: 1,
                    data: [24, 20, 10, 15] // Values for each month
                },
                // Add more datasets as needed
            ],
            chartOptions1: {
                scales: {
                    yAxes: [{
                        gridLines: {
                            display: false // Hide y-axis grid lines
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false // Hide x-axis grid lines
                        }
                    }]
                }
            },
            chartOptions: {

            },
            chartCandidate: {},
            selectedCandidate: {},
            scaleMarks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            category: [],
            
        }
    
      





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {

                this.GetDetailTotalCandidate();
                this.GetTotalCandidate();
                this.GetValueCategoryChart();
                this.GetValuePositiveNegativeChart();
            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {
        filteredList() {
            const query = this.searchQuery.toLowerCase().trim();
            if (!query) {
                return this.list;
            } else {
                return this.list.filter(item => {
                    // Adjust the condition based on your search criteria
                    return item.name.toLowerCase().includes(query);
                });
            }
        },

    },

    methods: {
        getFormattedValue(value) {
      if (isNaN(value)) {
        return '0.00';
      }
      return Number(value).toFixed(2);
    },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetDetailTotalCandidate() {
            try {
                const response = await this.$API.get(this.$GetDetailTotalCandidate);
                if (response.status === 200) {
                    this.chartCandidate = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetTotalCandidate() {
            try {
                const response = await this.$API.get(this.$GetTotalCandidate, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.selectedCandidate = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetValueCategoryChart() {
            try {
                const response = await this.$API.get(this.$GetValueDashboard, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.category = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetValuePositiveNegativeChart() {
      try {
        const response = await this.$API.get(this.$GetValueDashboardPositivenegative, {
          withCredentials: true,
        });
        if (response.status === 200) {
          this.pn = response.data;

          // Extract values from the API response
          this.positiveValue = this.pn.find(item => item.Name === "positive")?.Value || 0;
          this.negativeValue = this.pn.find(item => item.Name === "negative")?.Value || 0;

          // Prepare the datasets for the doughnut chart
          this.defaultDatasetsDoughnut = [
            {
              data: [this.positiveValue, this.negativeValue],
              backgroundColor: ['#928AFD', '#EF5350'], // Example colors
            },
          ];

          // Calculate the percentages
          const totalValue = this.positiveValue + this.negativeValue;
          this.positivePercentage = totalValue > 0 ? Math.round((this.positiveValue / totalValue) * 100) : 0;
          this.negativePercentage = totalValue > 0 ? Math.round((this.negativeValue / totalValue) * 100) : 0;
        } else {
          console.error("Failed to fetch user information:", response);
        }
      } catch (error) {
        console.error("Error fetching user information:", error);
      }
    },
        closePopup1() {
            this.isPopupVisible2 = false
        },
        OpenConfirmation() {
            this.isPopupVisible2 = true;
        },
        openVideoPopup(url) {
            this.videoUrl = url;
            this.isPopupVisible3 = true;
        },
        // Method to close the video popup
        closeVideoPopup() {
            this.isPopupVisible3 = false;
            // Optionally, you can clear the video URL when the popup is closed
            // this.videoUrl = '';
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },


    }

};
</script>